import React, { useState } from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { name, email, phone, message } = formData;

        const whatsappMessage = `היי בר, הודעה חדשה מהאתר BerBenAbu.%0A%0Aשם: ${name}%0Aטלפון: ${phone}%0Aאימייל: ${email}%0Aהודעה: ${message}`;

        window.open(`https://wa.me/972524706686?text=${whatsappMessage}`, '_blank');
    };

    return (
        <section id="contact" className="section contact-section bg-dark text-white">
            <div className="container">
                <div className="contact-wrapper">
                    <motion.div
                        className="contact-info"
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                    >
                        <h2 className="section-title text-white">צור קשר</h2>
                        <p>נשמח לשמוע על הפרויקט הבא שלכם.</p>
                        <div className="info-item">
                            <strong>טלפון:</strong> 052-4706686
                        </div>
                        <div className="info-item">
                            <strong>אימייל:</strong> studio@barbenabu.com
                        </div>
                        <div className="info-item">
                            <strong>כתובת:</strong> עפולה, ישראל
                        </div>
                    </motion.div>

                    <motion.form
                        className="contact-form"
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        onSubmit={handleSubmit}
                    >
                        <div className="form-group">
                            <input
                                type="text"
                                name="name"
                                placeholder="שם מלא"
                                required
                                value={formData.name}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <input
                                type="email"
                                name="email"
                                placeholder="אימייל"
                                required
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <input
                                type="tel"
                                name="phone"
                                placeholder="טלפון"
                                value={formData.phone}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <textarea
                                name="message"
                                placeholder="הודעה"
                                rows="4"
                                value={formData.message}
                                onChange={handleChange}
                            ></textarea>
                        </div>
                        <button type="submit" className="submit-button">שלח הודעה בוואטסאפ</button>
                    </motion.form>
                </div>
            </div>
        </section>
    );
};

export default Contact;
